"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInRequestToJSON = exports.SignInRequestFromJSONTyped = exports.SignInRequestFromJSON = void 0;
const _1 = require("./");
function SignInRequestFromJSON(json) {
    return SignInRequestFromJSONTyped(json, false);
}
exports.SignInRequestFromJSON = SignInRequestFromJSON;
function SignInRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'otpSessionId': json['otpSessionId'],
        'biographics': _1.BiographicsLookupFromJSON(json['biographics']),
    };
}
exports.SignInRequestFromJSONTyped = SignInRequestFromJSONTyped;
function SignInRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'otpSessionId': value.otpSessionId,
        'biographics': _1.BiographicsLookupToJSON(value.biographics),
    };
}
exports.SignInRequestToJSON = SignInRequestToJSON;
//# sourceMappingURL=SignInRequest.js.map